//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../../funcionales/FormContent";
import MarcoModal from "../../funcionales/MarcoModal";
import FormHeader from "../../funcionales/FormHeader";
import TextButton from "../../buttons/TextButton";
import Loading from "../../../routes/Loading";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../../functions/dataFunctions";
import { submitMovimientoLlaves } from "../data/Submits";
import { eventos } from "../data/FormContent";
//------------------------------------------------------ estilos
import "../css/Forms.css";

const FormMovimientoLlaves = ({ elemento = null, onGuardar, onClose }) => {
  const campos = eventos["llaves"];
  const titulo = "Control de llaves";
  const subtitulo = "Seguimiento de las llaves de los tractores";

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({});
  const [formData, setFormData] = useState({
    area: elemento?.area || "porteria",
    tipo: elemento?.tipo || null,
    operador: elemento?.operador || null,
    persona: elemento?.persona || null,
    tractor: elemento?.tractor || [],
    detalle: elemento?.detalle || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects();
      setListas(data);
      setLoading(false);
    };

    cargarDatos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitMovimientoLlaves(
      elemento,
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="doble-form">
          <div className="doble-form-content">
            <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />
            <div className="doble-form-modal">
              <FormContent
                elemento={elemento}
                campos={campos}
                opciones={listas}
                data={formData}
                setData={setFormData}
                isDouble={true}
              />
            </div>
            <div className="form-buttons">
              <TextButton
                text={"Guardar"}
                type={"button"}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormMovimientoLlaves;
